import { createContext, useContext } from 'react';
const reject = (message) => {
    throw new Error(message);
};
// --StaffServiceClient--
export const StaffClientContext = createContext(null);
export const useStaffServiceClient = () => useContext(StaffClientContext) ?? reject('StaffClientContext is not present. Use StaffClientContext.Provider.');
// --StaffWidgetsClient--
export const StaffWidgetsContext = createContext(null);
export const useStaffWidgetsClient = () => useContext(StaffWidgetsContext) ?? reject('StaffWidgetsContext is not present. Use StaffWidgetsContext.Provider.');
